// Plain CommonJS so `next-sitemap.config.js` can require it too (the package has
// no "type": "module"; webpack interops it for the app code).
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || 'https://placekit.io';

/**
 * Absolute, canonical URL for an internal path. The site has no trailing
 * slashes, home included: `/` resolves to `https://placekit.io`, so canonical,
 * hreflang, sitemap <loc> and JSON-LD all quote the exact same string.
 * @arg {string} [path='/'] Internal path.
 * @return {string}
 */
const absolute = (path = '/') => new URL(path, BASE_URL).href.replace(/(.)\/$/, '$1');

module.exports = { BASE_URL, absolute };
